import styled from 'styled-components'
import { Style } from '../../styles'

const WidgetContainer = styled.div`
  font-family: system-ui, "Open Sans", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji";
  user-select: none;

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    width: 100%;
    max-height: 100vh;
  }

  iframe {
    -webkit-tap-highlight-color: transparent;
    font-family: system-ui, "Open Sans", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji";
    font-size-adjust: none;
    font-size: 100%;
    font-style: normal;
    letter-spacing: normal;
    font-stretch: normal;
    font-variant: normal;
    font-weight: normal;
    text-align-last: initial;
    text-decoration: none;
    text-emphasis: none;
    text-indent: 0px;
    text-shadow: none;
    text-transform: none;
    alignment-baseline: baseline;
    animation-play-state: running;
    backface-visibility: visible;
    background-color: transparent;
    background-image: none;
    baseline-shift: baseline;
    border: 0px none transparent;
    border-radius: 0px;
    inset: auto;
    box-shadow: none;
    box-sizing: content-box;
    caption-side: top;
    clear: none;
    clip: auto;
    color: inherit;
    columns: auto;
    column-fill: balance;
    column-gap: normal;
    content: normal;
    counter-increment: none;
    counter-reset: none;
    cursor: auto;
    direction: ltr;
    display: inline;
    dominant-baseline: auto;
    empty-cells: show;
    float: none;
    height: auto;
    hyphenate-character: auto;
    hyphens: manual;
    image-rendering: auto;
    line-height: inherit;
    list-style: outside none disc;
    margin: 0px;
    max-height: none;
    max-width: none;
    min-height: 0px;
    min-width: 0px;
    opacity: 1;
    orphans: 2;
    outline-offset: 0px;
    overflow: visible;
    padding: 0px;
    page: auto;
    break-after: auto;
    break-before: auto;
    break-inside: auto;
    perspective: none;
    perspective-origin: 50% 50%;
    pointer-events: auto;
    position: static;
    quotes: none;
    resize: none;
    size: auto;
    table-layout: auto;
    transform: none;
    transform-origin: 50% 50% 0px;
    transform-style: flat;
    unicode-bidi: normal;
    vertical-align: baseline;
    white-space: normal;
    widows: 2;
    width: auto;
    word-break: normal;
    word-spacing: normal;
    overflow-wrap: normal;
    z-index: auto;
    text-align: start;
    -webkit-font-smoothing: antialiased;
  }
`

export default WidgetContainer